import { Statement } from '@domain/models'
import { mapSubtypes } from '@views/helpers'
import { centsToDollar, formatDate, formatStatementPeriod, toTitleString } from '@views/utils'
import jsPDF from 'jspdf'

const setFontWeight = (doc: jsPDF, weight: number) => {
  const helvetica = 'helvetica'
  const normal = 'normal'
  doc.setFont(helvetica, normal, weight)
}

const generateTopLeft = (doc: jsPDF) => {
  let verticalStart = 20
  let horizontalStart = 20
  let fontSize = 16
  doc.addImage(
    'data:image/png;base64,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',
    'PNG',
    horizontalStart,
    verticalStart,
    100,
    56.25
  )
  verticalStart += 56.25 + 10
  doc.setFontSize(fontSize)
  setFontWeight(doc, 700)
  doc.text('Players Health', horizontalStart, verticalStart)
  fontSize = 12
  verticalStart += 6 + fontSize
  setFontWeight(doc, 400)
  doc.setFontSize(fontSize)
  doc.text('718 Washington Ave N Ste 402', horizontalStart, verticalStart)
  verticalStart += 2 + fontSize
  doc.text('Minneapolis, MN 55401', horizontalStart, verticalStart)
}

const generateUserInfo = (
  doc: jsPDF,
  verticalStart: number,
  horizontalStart: number,
  statement: Statement,
  addressInfo: {
    street: string
    city: string
    state: string
  }
) => {
  setFontWeight(doc, 700)
  let fontSize = 12
  doc.setFontSize(fontSize)
  verticalStart += 6
  doc.text(
    `${statement.authorized_signer[0].first_name} ${statement.authorized_signer[0].last_name}`.toUpperCase(),
    horizontalStart,
    verticalStart
  )
  setFontWeight(doc, 400)
  verticalStart += fontSize + 8
  doc.text(`${addressInfo.street}`, horizontalStart, verticalStart)
  verticalStart += fontSize + 2
  doc.text(`${addressInfo.city}, ${addressInfo.state}`, horizontalStart, verticalStart)
  verticalStart += fontSize + 2
  doc.text('United States', horizontalStart, verticalStart)
}

const generateAccountInfo = (
  doc: jsPDF,
  verticalStart: number,
  horizontalStart: number,
  statement: Statement
) => {
  let fontSize = 12
  setFontWeight(doc, 700)
  doc.text('Statement period', horizontalStart, verticalStart)
  verticalStart += fontSize + 6
  setFontWeight(doc, 400)
  const startDate = formatDate(statement.start_date, 'MM/DD/YYYY')
  const endDate = formatDate(statement.end_date, 'MM/DD/YYYY')
  doc.text(`${startDate} - ${endDate}`, horizontalStart, verticalStart)
  setFontWeight(doc, 700)
  verticalStart += fontSize + 8
  doc.text('Account type', horizontalStart, verticalStart)
  verticalStart += fontSize + 6
  setFontWeight(doc, 400)
  doc.text(statement.account_summary.account_type, horizontalStart, verticalStart)
  setFontWeight(doc, 700)
  verticalStart += fontSize + 8
  doc.text('Account number', horizontalStart, verticalStart)
  verticalStart += fontSize + 6
  setFontWeight(doc, 400)
  doc.text(statement.account_summary.account_number, horizontalStart, verticalStart)
}

const generateAccountStatementTitle = (doc: jsPDF, statement: Statement) => {
  let verticalStart = 92.25
  let horizontalStart = 175
  let horizontalEnd = 440
  let fontSize = 20
  doc.setFontSize(fontSize)
  setFontWeight(doc, 700)
  doc.text('Account Statement', horizontalStart, verticalStart)
  verticalStart += 10
  doc.setLineWidth(2)
  doc.line(horizontalStart - 10, verticalStart, horizontalEnd, verticalStart)
  verticalStart += 12
  return { verticalStart, horizontalStart }
}

const generateTransactions = (doc: jsPDF, statement: Statement, pageNumber: number) => {
  let verticalStart = 250
  let horizontalStart = 20
  let horizontalEnd = 440
  let fontSize = 20
  doc.setFontSize(fontSize)
  setFontWeight(doc, 700)
  doc.text('Transaction details', horizontalStart, verticalStart)
  verticalStart += 10
  doc.setLineWidth(2)
  doc.line(horizontalStart - 10, verticalStart, horizontalEnd, verticalStart)
  verticalStart += 14
  fontSize = 12
  doc.setFontSize(fontSize)
  let dateHorizontal = horizontalStart
  doc.text('Posted Date', dateHorizontal, verticalStart)
  let descHorizontal = dateHorizontal + 60
  doc.text('Description', descHorizontal, verticalStart)
  let amtHorizontal = descHorizontal + 200
  doc.text('Amount ($)', amtHorizontal, verticalStart)
  let dcHorizontal = amtHorizontal + 100
  doc.text('Debit/Credit', dcHorizontal, verticalStart)

  verticalStart += 4
  doc.line(horizontalStart - 10, verticalStart, horizontalEnd, verticalStart)

  setFontWeight(doc, 400)
  doc.setLineWidth(0.5)
  doc.setLineDashPattern([1], 0)
  verticalStart += 12
  const pageHeight = doc.internal.pageSize
  for (const item of statement.transactions) {
    let postedDate = formatDate(item.posted_date, 'MM/DD/YYYY')
    doc.text(postedDate, dateHorizontal, verticalStart)
    let splitDesc = doc.splitTextToSize(mapSubtypes(item.subtype), 200)
    doc.text(splitDesc[0], descHorizontal, verticalStart)
    doc.text(
      `${item.data.dc_sign === 'debit' ? '-' : ''}${centsToDollar(
        item.data.lines[0].amount
      ).toFixed(2)}`,
      amtHorizontal,
      verticalStart
    )
    doc.text(toTitleString(item.data.dc_sign), dcHorizontal, verticalStart)
    verticalStart += 4
    doc.line(horizontalStart - 10, verticalStart, horizontalEnd, verticalStart)
    verticalStart += fontSize
    if (verticalStart >= pageHeight.getHeight() - 40) {
      addPage(doc, pageNumber)
      verticalStart = 20
      setFontWeight(doc, 400)
      doc.setLineWidth(0.5)
      doc.setLineDashPattern([1], 0)
    }
  }

  verticalStart += 50
  if (verticalStart >= pageHeight.getHeight() - 40) {
    addPage(doc, pageNumber)
    verticalStart = 20
  }
  doc.setLineDashPattern([], 1)
  doc.setLineWidth(2)
  doc.line(horizontalStart - 10, verticalStart, horizontalEnd, verticalStart)
  return verticalStart
}

const generateDisclaimer = (
  doc: jsPDF,
  verticalStart: number,
  statement: Statement,
  pageNumber: number
) => {
  const pageHeight = doc.internal.pageSize
  let horizontalStart = 20
  let horizontalEnd = 440
  verticalStart += 16

  if (verticalStart + 300 >= pageHeight.getHeight() - 40) {
    addPage(doc, pageNumber)
    verticalStart = 20
  }
  const happyFoxURL = `https://playershealth.happyfox.com/home/`
  const phoneNumber = `612-345-9683`
  const newStart = `Please go to ${happyFoxURL} or call us at ${phoneNumber} `
  const todoIndex = statement.disclosure.indexOf('as')
  const restOfString = statement.disclosure.slice(todoIndex)
  const newDisclosure = newStart + restOfString
  doc.text(newDisclosure, horizontalStart, verticalStart, {
    maxWidth: horizontalEnd - horizontalStart - 10,
  })
}

const addPage = (doc: jsPDF, pageNumber: number) => {
  doc.addPage()
  setFontWeight(doc, 400)
  const height = doc.internal.pageSize.getHeight() - 20
  const width = doc.internal.pageSize.getWidth() - 20
  doc.text(`${pageNumber}`, width, height)
  pageNumber++
}

export const generateStatementPDF = (
  statement: Statement,
  addressInfo: { street: string; state: string; city: string }
) => {
  const doc = new jsPDF({ orientation: 'p', unit: 'px', format: 'letter' })
  doc.setFontSize(12)
  let pageNumber = 1
  const height = doc.internal.pageSize.getHeight() - 20
  const width = doc.internal.pageSize.getWidth() - 20
  doc.text(`${pageNumber}`, width, height)
  pageNumber++
  generateTopLeft(doc)
  let { verticalStart, horizontalStart } = generateAccountStatementTitle(doc, statement)
  generateUserInfo(doc, verticalStart, horizontalStart, statement, addressInfo)
  verticalStart += 6
  horizontalStart += 160
  generateAccountInfo(doc, verticalStart, horizontalStart, statement)
  verticalStart = generateTransactions(doc, statement, pageNumber)
  generateDisclaimer(doc, verticalStart, statement, pageNumber)
  doc.save(formatStatementPeriod(statement.start_date))
}
